<template>
  <div class="ControlWrapping">
    <div class="iconList">
      <i
        class="el-icon-video-camera"
        :class="{startRecord}"
        @click="recordVideo"
      ></i>
      <i
        class="el-icon-camera"
        @click="screenshot"
      ></i>
      <i
        class="el-icon-cloudy"
        @click="control"
      ></i>
      <svgIcon
        v-if="!fullScreen"
        class="icon"
        icon-class="fullscreen"
        @click="full"
      />
      <svgIcon
        v-if="fullScreen"
        class="icon"
        icon-class="exit-fullscreen"
        @click="full"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    player: {
      type: Object,
      default: () => { return {} }
    },
    startRecord: {
      type: Boolean,
      default: false
    },
    fullScreen: {
      type: Boolean,
      default: false
    }

  },
  data() {
    return {
    }
  },

  mounted() {

  },

  methods: {
    recordVideo() {
      if (this.startRecord) {
        this.player.stopSave()
      } else {
        this.player.startSave()
      }
    },
    screenshot() {
      this.player.capturePicture()
    },
    control() {
      this.$emit('control')
    },
    full() {
      this.$emit('fullScreen')
    }
  }
}
</script>

<style lang="scss" scoped>
.ControlWrapping{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 40px;
    background: rgba(0,0,0,.4);
    .iconList{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        color:#fff;
        padding-right: 20px;
        i{
            font-size: 24px;
            cursor: pointer;
            margin-right: 20px;

        }
        .icon{
            font-size: 18px;
            cursor: pointer;
        }
        .startRecord{
            color: red;
        }
    }
}
</style>

